module.exports = __webpack_public_path__ + "static/media/ThebanHoplite.9a046891.jpg";